
import ruleSelector from 'modules/RuleEngine/selectors'
import { connect } from 'react-redux'

import {
  
  getRuleSetData,
  deleteRule
  
} from 'modules/RuleEngine/action'

import RuleEngineDraft from '..'

const mapStateToProps = state => ({
  
  ruleSet: ruleSelector.getRuleSetData(state),
  
})

const mapDispatchToProps = {
 
  deleteRule,
  
  getRuleSetData,
  
}

export default connect(mapStateToProps, mapDispatchToProps)(RuleEngineDraft)
